import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import { Card, Badge, Banner, Bleed, Divider, InlineGrid, InlineStack, Icon, InlineError, List, Pagination, Popover, Select, Text, TextField, Tooltip, BlockStack } from '@shopify/polaris';
import { ChevronDownMinor, CircleCancelMinor, CircleInformationMajor, CircleTickMinor, DiamondAlertMajor } from '@shopify/polaris-icons';
import SearchSKU from './SearchSKU';
import { changeSyncStatus, customModal, getCalculatedAmount, getModalOrderId, getShopifyOrderId, getShopifyShopUrl, getSourceShopID, getSyncStatus, getToolTipContent, necessaryDetails } from '../Utils/Helper';
import { appBridgeRedirect } from '../../Panel/index';
import { Table } from 'antd';
// import FailedRefundOrder from '../Utils/OrderModals/FailedRefundOrder';
import { amazonReasons, cancellationModalGridColumns, refundModalGridColumns, shopifyReasons } from '../Utils/Constants';
import { InfoIcon } from 'src/Asests/svgIcon/icon';
import { useTranslation } from 'react-i18next';
import RefundModal from './RefundModal';
import FailedOrderModal from './FailedOrderModal';

interface props extends DIProps {
    row: any
    getAllOrders: () => void
}

const RenderSyncStatus = (props: props) => {
    const { t } = useTranslation();
    const { refundModalGridCols } = refundModalGridColumns();
    const { amazonReasonsOpt } = amazonReasons();
    const { row, getAllOrders } = props;
    const { shopifyReasonOpt } = shopifyReasons();
    const { cancellationModalOpt } = cancellationModalGridColumns();
    const shopify_order_id = getShopifyOrderId(row);
    const shopifyUrl = getShopifyShopUrl(shopify_order_id, props);
    let itemsCountOnGrid: number = 5;

    const [popoverActive, setPopoverActive] = useState<boolean>(false);
    const [openFailedModal, setOpenFailedModal] = useState<any>({
        open: false,
        loading: false
    })
    const [errorMessage, setErrorMessage] = useState<any>({});
    const [activePage, setActivePage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
    const [shipmentErrModal, setShipmentErrModal] = useState<any>({
        open: false,
        loading: false
    })
    const [cancellationModal, setCancellationModal] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any>({});
    const [modalGridRows, setmodalGridRows] = useState<any>([]);
    const [cancelLoader, setCancelLoader] = useState<boolean>(false);
    const [shopifyReason, setShopifyReason] = useState<string>('');
    const [activateConfirmationModal, setactivateConfirmationModal] = useState<boolean>(false);
    const [shopifyError, setShopifyError] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    let [currentItemCount, setcurrentItemCount] = useState<number>(0);
    let [orderItemCount, setorderItemCount] = useState<number>(itemsCountOnGrid);
    const [failedRefundOrderModal, setFailedRefundOrderModal] = useState<boolean>(false);
    const [refundmodalData, setRefundModalData] = useState<any>({});
    const [refundModalGridRows, setRefundModalGridRows] = useState<any>([]);
    const [selectedRowIndexes, setselectedRowIndexes] = useState<any>([]);
    const [errors, setErrors] = useState<any>([]);
    const [activateConfirmationRefundModal, setactivateConfirmationRefundModal] = useState<boolean>(false);
    const [refloader, setRefLoader] = useState<boolean>(false);
    const [refundLoader, setRefundLoader] = useState<boolean>(false)
    const [modalDataForFutureUse, setModalDataForFutureUse] = useState<any>({});

    // const shopifyReasons = [
    //     { label: "Please Select", value: "", disabled: true },
    //     { label: "Customer", value: "customer" },
    //     { label: "Inventory", value: "inventory" },
    //     { label: "Fraud", value: "fraud" },
    //     { label: "Declined", value: "declined" },
    //     { label: "Other", value: "other" },
    // ];

    const modalGridColumns = [
        {
            title: 'Product Name',
            dataIndex: 'item_name',
        },
        {
            title: 'Inventory',
            dataIndex: 'inventory',
        },
        {
            title: 'Cancelation Reason (Amazon)',
            dataIndex: 'cancellation_reason',
        },
        {
            title: 'Total Item Price',
            dataIndex: 'total_item_price',
        }
    ];

    useEffect(() => {
        handleTotalpage(row?.items?.length)
    }, [row])

    const handleTotalpage = (totalProduct: number) => {
        if (totalProduct > 0) {
            if (totalProduct % orderItemCount == 0) {
                totalProduct = totalProduct / orderItemCount;
            } else {
                totalProduct = Math.trunc(totalProduct / orderItemCount) + 1;
            }
            setTotalPage(totalProduct);
        } else {
            setTotalPage(0);
        }
    };

    const createFailedOrder = async () => {
        setOpenFailedModal({ ...openFailedModal, loading: true })
        let obj: any = {
            ...necessaryDetails(props),
            "target_shop_id": props?.redux?.current?.target?.['_id'],
            "target_marketplace": "amazon",
            "cif_order_id": row?.["cif_order_id"]
        }
        if (row?.['cif_order_id'] && row?.["cif_order_id"] != "") {
            let response = await props.di.POST('connector/order/createOrder', obj);
            setOpenFailedModal({ open: false, loading: false })
            if (response?.success) {
                props?.success("Order created successfully.");
            }
            else {
                if (response?.data) {
                    if (response?.message && typeof response.message == 'string') {
                        props.error(response?.message)
                    }
                    response?.data?.forEach((ele: any) => {
                        if (ele?.['shop_id'] == props?.redux?.current?.source?.['_id']) {
                            props?.error(ele?.['errors']?.[0]);
                        }
                    });

                    if (response?.message) {
                        props.error(response?.message)
                    }
                } else {
                    if (response?.message && typeof response.message == 'object' && response.message?.save) {
                        Object.values(response.message.save).forEach((ele: any) => {
                            ele.failed != undefined && ele.failed[0].reason != "undefined" && props?.error(ele.failed[0]?.reason ?? "Oops! Some error occured.")
                        })
                    } else {
                        props?.error(typeof response?.message != "string" ? response.message : "Oops! Some error occured.")
                    }
                }
            }
        }
        else {
            props?.error("Given order is not found")
        }


    }

    const handlePreviousPagination = () => {
        setcurrentItemCount(currentItemCount => currentItemCount - itemsCountOnGrid)
        setorderItemCount(orderItemCount => orderItemCount - itemsCountOnGrid)
        setActivePage(activePage => activePage - 1)
    }

    const handleNextPagination = () => {
        setcurrentItemCount(currentItemCount => currentItemCount + itemsCountOnGrid)
        setorderItemCount(orderItemCount => orderItemCount + itemsCountOnGrid)
        setActivePage(activePage => activePage + 1)
    }

    const renderFailedORderItems = useCallback((items: any) => {
        let render: any = [];

        items?.slice(currentItemCount, orderItemCount)?.map((item: any, idx: number) => {
            render?.push(
                <React.Fragment key={idx}>
                    <div className={errorMessage.change ? 'CardDull' : ''}>
                        <InlineGrid columns={'2'} alignItems='center' key={idx}>
                            <BlockStack gap="200">
                                <Text as='p' variant='bodyMd' fontWeight='semibold'>{item?.title || ''}</Text>
                                {
                                    item?.sku &&
                                    <Text as='p'>SKU: {item?.sku}</Text>
                                }
                            </BlockStack>

                            <SearchSKU item={item} row={row} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} errorMessage={errorMessage} setErrorMessage={setErrorMessage} />
                        </InlineGrid>
                    </div>
                    <Divider />
                </React.Fragment>
            )
        })
        return render;
    }, [currentItemCount, orderItemCount, errorMessage])


    const renderErrBanner = useCallback(() => {
        return errorMessage.change ?
            <Banner tone='critical'>{row?.items?.length > 1 ? "Some products are not present on Amazon" : errorMessage.msg}</Banner>
            :
            <></>
    }, [errorMessage])

    const getModifiedModalGridRows = (data: any) => {
        let rows: any = [];
        rows = data?.['items']?.map((obj: any, index: number) => {
            let row: any = {
                key: index,
                item_name: obj?.['title'] ?? "",
                inventory: obj?.['qty'] ?? "",
                cancellation_reason: obj?.['marketplace_cancel_reason'] ?? "---",
                total_item_price:
                    <InlineStack gap="500">
                        <Text as='p'>{obj?.['currency']}
                            {getCalculatedAmount({ ...obj })}
                        </Text>
                        {/* <Text as='p'>{data?.['marketplace_currency']} {(obj?.['marketplace_price'] * obj?.['qty']) + obj?.['tax']?.['marketplace_price'] ?? 0 - obj?.['discount']?.['marketplace_price'] ?? 0}</Text> */}
                        <Tooltip content={getToolTipContent({ ...obj }, data?.['currency'], t)}>
                            <div><Icon source={CircleInformationMajor} tone="base" /></div>
                        </Tooltip>
                    </InlineStack>

            }
            return row;
        });
        return rows;
    }

    const handleCancelBtn = async (id: string) => {
        props.di.GET("connector/order/getFailedCancelOrder", {
            "marketplace_reference_id": id,
        }).then((response: any) => {

            if (response.success) {
                setModalData({ ...response?.data?.[0] })
                let modalGridRows: any = getModifiedModalGridRows(response?.data?.[0]);
                setmodalGridRows([...modalGridRows]);
                setCancellationModal(!cancellationModal);
            }
            else {
                props.error(t(response.message) ?? "Oops! Some error occured while getting single order details.")
            }
        })
    }

    const handleModalClose = () => {
        setModalData({});
        setmodalGridRows([]);
        setCancellationModal(false)
    }

    const handleCancelOrderModal = () => {
        if (shopifyReason != "") {
            setCancellationModal(false);
            setactivateConfirmationModal(true);
        }
        else {
            setShopifyError(true);
            props.error(t("Kindly select shopify reason before proceeding."))
        }
    }

    const handleConfirmationModal = () => {
        setCancelLoader(true);
        props.di.POST("connector/order/manualCancel", {
            ...modalData, "cancel_reason": shopifyReason
        }).then((response: any) => {
            setCancelLoader(false)
            setactivateConfirmationModal(false);
            if (response.success) {
                props.success(t(response.message));
                getAllOrders()
            }
            else {
                props.error(t(response.message) ?? t("Oops! Some error occured while cancelling order."))
            }
        });
    }

    let cancellation_order_id = getModalOrderId(modalData);

    //  <<---- Refund functions ----->>>
    useEffect(() => {
        if (Object.keys(refundmodalData).length > 0 && refundmodalData?.items && refundmodalData?.items.length > 0) {
            let modalRows: any = getRefundModifiedModalGridRows({ ...refundmodalData });
            setRefundModalGridRows([...modalRows]);
        }
    }, [refundmodalData]);

    useEffect(() => {
        if (errors && errors.length > 0) {
            let modalRows: any = getRefundModifiedModalGridRows({ ...refundmodalData });
            setRefundModalGridRows([...modalRows]);
        }
    }, [errors])

    function preventScroll(e: any) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    function disable(type: string, index: number) {
        if (type == "inventory") {
            let icon = document.getElementsByClassName('toolTipScroll1')[index];
            icon?.addEventListener('wheel', preventScroll);
        }
        else {
            let icon = document.getElementsByClassName('toolTipScroll')[index];
            icon?.addEventListener('wheel', preventScroll);
        }
        let myElem = document.getElementsByClassName('Polaris-PositionedOverlay')[0]
        myElem?.addEventListener('wheel', preventScroll);
    }

    const getModalInventory = (data: any, index: number) => {
        return (
            <InlineStack gap="100" blockAlign='center' wrap={false}><Select
                label=""
                labelHidden

                value={refundmodalData?.items?.[index]?.refund_qty ? refundmodalData?.items?.[index]?.refund_qty + "" : undefined}
                onChange={(e) => {
                    let tempModalData = { ...refundmodalData };
                    tempModalData['items'][index]['refund_qty'] = parseInt(e);
                    tempModalData['items'][index]['refund_amount'] = "0";
                    setRefundModalData({ ...tempModalData });

                    let tempErrors = [...errors];
                    tempErrors[index]['refund_qty'] = e == "";
                    tempErrors[index]['refund_amount'] = true;
                    setErrors([...tempErrors])
                }}
                disabled={refundmodalData?.items?.[index]?.disabled}
                options={[{ label: "Please Select", value: "", disabled: true }, ...Array.from({ length: data?.qty }, (_, i) => i + 1).map((num: number) => { return { label: num + "", value: num + "" } })]}
                error={errors?.[index]?.['refund_qty']} />
                {modalDataForFutureUse?.items?.[index]?.refund_qty &&
                    <div className='toolTipScroll1' onMouseEnter={() => disable("inventory", index)} onMouseOver={() => disable("inventory", index)}>
                        <Tooltip content={`Inventory refunded on shopify : ${modalDataForFutureUse?.items?.[index]?.refund_qty}`}>
                            <Icon source={CircleInformationMajor} tone={'info'} />
                        </Tooltip>
                    </div>}
            </InlineStack>
        )
    }

    const getModalRefundReason = ((data: any, index: number) => {
        return <Select
            label=""
            labelHidden
            value={refundmodalData?.items?.[index]?.refund_reason ?? ""}
            onChange={(e) => {
                let tempModalData = { ...refundmodalData };
                tempModalData['items'][index]['refund_reason'] = e;
                setRefundModalData({ ...tempModalData })
                let tempErrors = [...errors];
                tempErrors[index]['refund_reason'] = e == "";
                setErrors([...tempErrors])
            }}
            disabled={refundmodalData?.items?.[index]?.disabled}
            options={amazonReasonsOpt}
            error={errors?.[index]?.['refund_reason']} />
    })

    const getModalRefundAmount = ((data: any, index: number, total: number) => {
        return <TextField
            type={'number'}
            label=""
            labelHidden
            value={refundmodalData?.items?.[index]?.refund_amount ?? "0"}
            onChange={(e) => {
                let tempModalData = { ...refundmodalData };
                tempModalData['items'][index]['refund_amount'] = e;
                setRefundModalData({ ...tempModalData });

                let tempErrors = [...errors];
                if (e == "" || e.trim().length == 0 || e == '0') {
                    tempErrors[index]['refund_amount'] = true;
                }
                else {
                    tempErrors[index]['refund_amount'] = + e > total
                }
                setErrors([...tempErrors])
            }}
            disabled={refundmodalData?.items?.[index]?.disabled}
            autoComplete="off"
            placeholder='Enter refund amount'
            error={errors?.[index]?.['refund_amount']} />
    })

    const getAdditionalPrices = (currency: string, data: any, item: any) => {
        let jsx: any = "";

        if (data?.additional_prices && Array.isArray(data?.additional_prices) && data?.additional_prices?.length > 0) {
            jsx = data?.additional_prices?.map((obj: any, idx: number) => {
                const tax = +((Math.floor(item?.tax?.marketplace_price / item?.qty * 1000) / 1000) ?? 0);
                const qty = +(item?.refund_qty ?? 0);
                return <InlineStack gap="100" key={obj?.code ?? idx}>
                    <Text as='p'>{obj?.code} : </Text>
                    <Text as='p'>{currency} {(tax * qty) ?? 0.00}</Text>
                </InlineStack>
            })
        }
        return jsx;
    }

    const getRefundToolTipContent = (currency: string, data: any, item: any) => {

        return (
            <BlockStack gap="100">
                <InlineStack gap="100">
                    <Text as='p'>Item Price : </Text>
                    <Text as='p'>{currency} {data?.['price']['marketplace_price'] ?? 0.00}</Text>
                </InlineStack>
                <InlineStack gap="100">
                    <Text as='p'>Item Discount : </Text>
                    <Text as='p'>{currency} {data?.['discount']?.['marketplace_price'] ?? 0.00}</Text>
                </InlineStack>
                {getAdditionalPrices(currency, data, item)}
            </BlockStack>
        )
    }

    const getRefundModifiedModalGridRows = (data: any) => {
        let rows: any = [];
        rows = data?.['items'].map((obj: any, index: number) => {
            const item = refundmodalData?.items?.[index];
            const price = +(item?.price?.marketplace_price ?? 0);
            const qty = +(item?.refund_qty ?? 0);
            const tax = +(item?.tax?.marketplace_price / item?.qty ?? 0);
            const shipping = +(item?.shipping_charge?.marketplace_price ?? 0);
            const discount = +(item?.discount?.marketplace_price ?? 0);
            const total = Math.floor((price * qty + (tax * qty) + shipping - discount) * 1000) / 1000;
            let row: any = {
                key: obj?.id,
                item_name: obj?.['title'] ?? "---",
                inventory: getModalInventory({ ...obj }, index),
                refund_reason: getModalRefundReason({ ...obj }, index),
                total_item_price:
                    <InlineStack gap="200" blockAlign='center' wrap={false}>
                        <Text as='p'>{obj?.['currency']}
                            {obj?.['currency']}{total}
                        </Text>
                        <div className='toolTipScroll' onMouseEnter={() => disable("pricing", index)} onMouseOver={() => disable("pricing", index)}>
                            <Tooltip content={getRefundToolTipContent(data?.currency, { ...obj }, obj)}>
                                <Icon source={CircleInformationMajor} tone={'base'} />
                            </Tooltip>
                        </div>
                    </InlineStack>
                ,
                refund_amount: getModalRefundAmount({ ...obj }, index, total),
            }
            return row;
        });
        return rows;
    }

    const getModifiedModalData = (data: any) => {
        let modifiedItemsArr = data?.items?.map((obj: any, index: number) => {
            if (obj.hasOwnProperty("refund_qty")) return {
                ...obj,
                refund_reason: "",
                refund_amount: "0",
                disabled: true,
            }
            else return {
                ...obj,
                refund_reason: "",
                refund_amount: "0",
                refund_qty: "",
                disabled: true,
            }
        });
        data = { ...data, items: modifiedItemsArr }
        console.log(data, "kdhvckljavckljavcklasjvc")
        return data;
    }

    const handleCreateRefund = async (data: any) => {
        setFailedRefundOrderModal(true)
        setRefLoader(true);
        props.di.GET("connector/order/getFailedRefund", {
            "cif_order_id": data?.['cif_order_id'],
            "object_type": data?.object_type,
        }).then((response: any) => {
            setRefLoader(false)
            if (response.success) {
                let modifiedModalData = getModifiedModalData({ ...response?.data });
                setModalDataForFutureUse(JSON.parse(JSON.stringify(modifiedModalData)));
                setRefundModalData({ ...modifiedModalData });
                let tempErrors = modifiedModalData?.items.map((obj: any) => {
                    return { refund_qty: false, refund_reason: false, refund_amount: false, id: obj?.id }
                })
                setErrors([...tempErrors]);
            }
            else {
                props.error(t(response.message) ?? t("Oops! Some error occured while getting items details"))
            }
        })
    }

    const validator = () => {
        let hasError = false;
        let tempErrors = [...errors];
        if (selectedRowIndexes.length == 0) {

            hasError = true;
        }


        refundmodalData?.items?.filter((item: any) => selectedRowIndexes.includes(item?.id)).map((obj: any) => {

            const price = +(obj?.price?.marketplace_price ?? 0);
            const qty = +(obj?.refund_qty ?? 0);
            const tax = +(obj?.tax?.marketplace_price / obj?.qty ?? 0);
            const shipping = +(obj?.shipping_charge?.marketplace_price ?? 0);
            const discount = +(obj?.discount?.marketplace_price ?? 0);
            const total = Math.floor((price * qty + (tax * qty) + shipping - discount) * 1000) / 1000;
            const refundAmountInvalid = (
                obj?.refund_amount === "" ||
                obj?.refund_amount.trim().length === 0 ||
                +obj?.refund_amount === 0 ||
                +obj?.refund_amount > total
            );
            if (obj?.refund_qty == "" || +obj?.refund_qty > +obj?.qty) {
                hasError = true;
                tempErrors.map((errorObj: any) => {
                    if (errorObj?.id == obj?.id) {
                        errorObj.refund_qty = true;
                    }
                })
            }
            if (refundAmountInvalid) {
                hasError = true;
                tempErrors.map((errorObj: any) => {
                    if (errorObj?.id == obj?.id) {
                        errorObj.refund_amount = true;
                    }
                })
            }
            if (obj?.refund_reason == "") {
                hasError = true;
                tempErrors.map((errorObj: any) => {
                    if (errorObj?.id == obj?.id) {
                        errorObj.refund_reason = true;
                    }
                })
            }
        });
        return { hasError, tempErrors }
    }

    const handleRefundOrderConfirmation = () => {
        let { hasError, tempErrors } = validator();
        if (!hasError) {
            setFailedRefundOrderModal(false);
            setactivateConfirmationRefundModal(true);
        }
        else {
            setErrors([...tempErrors])
            props?.error("Some information is missing or wrong, kindly check them before proceeding.");
        }
    }

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
            setselectedRowIndexes(selectedRowKeys)
            let tempModalData = { ...refundmodalData };
            tempModalData?.items?.map((obj: any, index: number) => {
                if (selectedRowKeys.includes(obj?.id)) {
                    tempModalData.items[index]['disabled'] = false
                }
                else {
                    tempModalData.items[index]['disabled'] = true
                }
            });
            setRefundModalData({ ...tempModalData })
        },
        onSelect: (record: any, selected: any, selectedRows: any) => {
            if (!selected) {
                flushErrors(record.key);
            }
        },
    };

    const flushErrors = (id: any) => {
        let tempErrors: any = [...errors];
        let idx: any = tempErrors.findIndex((x: any) => x.id === id);
        if (idx > -1) {
            tempErrors[idx] = {
                id: id,
                refund_amount: false,
                refund_qty: false,
                refund_reason: false
            }
        }
        setErrors(tempErrors);
    }

    const getTotalRefundAmount = () => {
        let sum: number = 0;
        refundmodalData?.items?.map((obj: any) => {
            sum += +obj?.refund_amount;
        })
        return sum;
    }

    const handleConfirmationModalClose = () => {
        setactivateConfirmationRefundModal(false);
    }

    const getFilteredItems = () => {
        let filteredItems: any = []
        selectedRowIndexes.map((index: number) => {
            refundmodalData?.items?.map((obj: any, itemsIndex: number) => {
                if (index == obj?.id) {
                    filteredItems.push(obj);
                }
            })
        });
        return filteredItems;
    }

    const getfilteredKeysForBackend = (arr: any) => {
        let updatedArr: any = [];
        updatedArr = arr?.map((obj: any, index: number) => {
            console.log(obj, "kjwdkjvkej")
            return {
                sku: obj?.sku,
                refund_amount: obj?.refund_amount,
                refund_qty: obj?.refund_qty,
                refund_reason: obj?.refund_reason,
            }
        });
        return updatedArr;
    }

    const handleRefundConfirmationModal = () => {
        setRefundLoader(true);
        let filteredItems = getFilteredItems();
        let filteredKeysForBackend = getfilteredKeysForBackend([...filteredItems])
        props.di.POST("connector/order/manualRefund", {
            "data": {
                "id": refundmodalData?._id?.$oid,
                "items": [...filteredKeysForBackend]
            }
        }).then((response: any) => {
            setRefundLoader(false)
            handleConfirmationModalClose();
            if (response.success) {
                getAllOrders();
                props.success(t(response?.message));
            }
            else {
                props.error(t(response?.message) ?? t("Oops! Some error occured while refunding order."))
            }
        });
    }

    //  <<---- Refund functions ----->>>

    // <<------ Render Sync Status Badge functions ----->>
    const syncStatusBadge = (primaryStatus: any) => {
        let id: string = '';

        if (row?.targets) {
            id = row?.targets?.map((target: any) => {
                if (target?.shop_id && target?.shop_id === getSourceShopID(props)) {
                    return target?.order_id;
                }
            })
        }
        switch (primaryStatus) {
            case 'Created':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div><Icon source={CircleTickMinor} tone="success" /></div>
                        <Text variant="bodySm" as="p">
                            {changeSyncStatus(primaryStatus, t)}
                        </Text>
                    </InlineStack>
                )
            case 'Shipped':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div><Icon source={CircleTickMinor} tone='success' /></div>
                        <Text variant="bodySm" as="p">
                            {primaryStatus}
                        </Text>
                    </InlineStack>
                );
            case 'Order':
                return (
                    <div className='Custom__Error--Icon' onClick={() => setOpenFailedModal({
                        ...openFailedModal, open: true
                    })}>
                        <Badge icon={DiamondAlertMajor} tone="critical">{changeSyncStatus(primaryStatus, t)}</Badge>
                    </div>
                );
            case 'Shipment':
                return (
                    <div className='Custom__Error--Icon' onClick={() => setShipmentErrModal({ ...shipmentErrModal, open: true })}>
                        <Badge icon={DiamondAlertMajor} tone="critical">{changeSyncStatus(primaryStatus, t)}</Badge>
                    </div>
                );
            case 'Cancellation':
                return (
                    <div className='Custom__Error--Icon' onClick={() => handleCancelBtn(id)}>
                        <Badge icon={DiamondAlertMajor} tone="critical">{changeSyncStatus(primaryStatus, t)}</Badge>
                    </div>
                );
            case 'Refund':
                return (
                    <div className='Custom__Error--Icon' onClick={() => handleCreateRefund(row)}>
                        <Badge icon={DiamondAlertMajor} tone="critical">{changeSyncStatus(primaryStatus, t)}</Badge>
                    </div>
                );
            case 'Cancelled':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div>
                            <Icon source={CircleCancelMinor} tone="caution" />
                        </div>
                        <Text variant='bodySm' as='p'>{changeSyncStatus(primaryStatus, t)}</Text>
                    </InlineStack>
                )
            case 'Refunded':
                return (
                    <InlineStack gap="100" blockAlign='center'>
                        <div>
                            <Icon source={CircleTickMinor} tone="success" />
                        </div>
                        <Text variant="bodySm" as="p">{changeSyncStatus(primaryStatus, t)}</Text>
                    </InlineStack>
                )

            case 'Refund_in_progress':
                return (
                    <Badge tone="info">{changeSyncStatus(primaryStatus, t)}</Badge>
                )


        }
    }

    const renderSyncStatusStructure = () => {
        let render = <></>;
        let { primaryStatus, remainingCount, remaingingStatus } = getSyncStatus(row, props);

        if (primaryStatus && primaryStatus !== "") {
            if (remainingCount > 0) {
                render = <InlineStack gap="200" blockAlign='center'>
                    {syncStatusBadge(primaryStatus)}
                    <Text as="p" fontWeight="bold">
                        +{remainingCount}
                    </Text>
                    <div style={{ cursor: 'pointer' }}>
                        <Popover
                            active={popoverActive}
                            preferredAlignment="right"
                            activator={
                                <div onClick={() => {
                                    setPopoverActive(!popoverActive)
                                }}>
                                    <Icon source={ChevronDownMinor} tone='subdued' />
                                </div>

                            }
                            autofocusTarget="first-node"
                            onClose={() => setPopoverActive(!popoverActive)}
                        >
                            <Card padding='300'>
                                {
                                    remaingingStatus?.map((status: any, idx: number) => {
                                        return <React.Fragment key={idx}>
                                            {syncStatusBadge(status)}
                                        </React.Fragment>
                                    })
                                }
                            </Card>
                        </Popover>
                    </div>
                </InlineStack>
            }
            else {
                render = <React.Fragment>{syncStatusBadge(primaryStatus)}</React.Fragment>
            }
        }
        else {
            render = <Badge tone="new">{t("Other")}</Badge>
        }
        return render;
    }

    const handleRefundModalClose = () => {

        setRefundModalData({});
        setRefundModalGridRows([]);
        setFailedRefundOrderModal(false);
        setselectedRowIndexes([])

    }

    // <<------ Render Sync Status Badge functions ----->>
    return (
        <React.Fragment>

            {renderSyncStatusStructure()}

            {/* <FailedOrderModal errorMessage={errorMessage} {...props} setErrorMessage={setErrorMessage} open={openFailedModal} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} createFailedOrder={createFailedOrder} row={row} setOpenFailedModal={setOpenFailedModal} /> */}
            {/* failed order modal */}
            {
                customModal(
                    openFailedModal?.open,
                    () => setOpenFailedModal({
                        open: false,
                        loading: false
                    }),
                    `${t("Failed Order")} (${row?.marketplace_reference_id ?? "N/A"})`,
                    {
                        content: t('Create Order on Shopify'),
                        disabled: selectedOptions.length === 0,
                        onAction: createFailedOrder,
                        loading: openFailedModal?.loading
                    },
                    <BlockStack gap='300'>
                        <InlineStack gap='100'>
                            <Text as='p' fontWeight='semibold'>{t("Failed order reason")}:</Text>
                            <Text as='p'>
                                {
                                    row?.targets &&
                                    row?.targets?.map((trgt: any) => {
                                        if (trgt?.shop_id === props.di.globalState.get('source_id')) {
                                            if (trgt?.errors)
                                                return trgt?.errors.join(',')
                                        }
                                    })
                                }
                            </Text>
                        </InlineStack>
                        <List type="number">
                            <List.Item >{t("If the ordered product is available in App")}:</List.Item>
                            <List type="bullet">
                                <List.Item >{t("Enter the product's in-app SKU to locate and associate it with its corresponding product in the app.")}</List.Item>
                                <List.Item>{t("Once linked, click the 'Create on Shopify' button to generate the order within your Shopify platform.")}</List.Item>
                            </List>
                        </List>
                        <Bleed marginInline="200" />
                        <Divider />
                        <Bleed marginInline='400' />
                        {renderErrBanner()}
                        {
                            row?.items?.length > 0 &&
                            <>
                                <InlineGrid columns='2' alignItems='center'>
                                    <Text as='p' fontWeight='semibold'>{t("Ordered Items")}</Text>
                                    <Text as='p' fontWeight='semibold'>{t("Search and Link product")}</Text>
                                </InlineGrid>
                                <Divider />
                                {renderFailedORderItems(row?.items)}
                                <InlineStack align="center" gap="400">
                                    <Pagination
                                        label={`${activePage}/${totalPage}`}
                                        hasPrevious={activePage > 1}
                                        onPrevious={() => {
                                            handlePreviousPagination()
                                        }}
                                        hasNext={activePage < totalPage}
                                        onNext={() => {
                                            handleNextPagination()
                                        }}
                                    />
                                </InlineStack>
                            </>
                        }
                    </BlockStack>
                    ,
                    true
                )
            }

            {/* Shipment Error modal */}


            {
                customModal(
                    shipmentErrModal.open,
                    () => setShipmentErrModal({ ...shipmentErrModal, open: false }),
                    `${t("Failed Shipment Order")} (${row?.marketplace_reference_id ?? "N/A"})`,
                    {
                        content: t("Go to Shopify Order"),
                        onAction: () => {
                            appBridgeRedirect(shopifyUrl, props)
                            setShipmentErrModal({ ...shipmentErrModal, open: false })
                        }
                    },
                    <BlockStack>
                        <InlineStack gap="100">
                            <Text as="p" fontWeight="semibold">
                                {t("Failed Shipment Reason")}:
                            </Text>
                            <Text as="p">
                                {
                                    Array.isArray(row?.shipment_error) && row.shipment_error.length > 0
                                        ? row.shipment_error[row.shipment_error.length - 1]
                                        : ""
                                }
                            </Text>
                        </InlineStack>
                    </BlockStack>,
                    true
                )
            }

            {/* Cancellation Modal */}
            {
                customModal(
                    cancellationModal,
                    () => handleModalClose(),
                    `${t("Failed Canceled Order")} (${cancellation_order_id})`,
                    {
                        content: t('Confirm'),
                        onAction: handleCancelOrderModal,
                        loading: cancelLoader
                    },
                    <BlockStack gap="500">
                        {
                            row?.targets?.filter((target: any) => target.shop_id == getSourceShopID(props))?.[0]?.cancellation_status === 'Disabled' &&
                            <InlineError message={t('Order syncing for cancellation is disabled from settings.')} fieldID='' />
                        }
                        <Card padding='0' roundedAbove='sm'>
                            <Table
                                columns={cancellationModalOpt}
                                dataSource={modalGridRows}
                                scroll={{ x: 800 }}
                                pagination={false}
                                loading={loader}
                                footer={() =>
                                    <InlineStack align='start'>
                                        <div className='Custom-Stack-Item--fill'>
                                            <Text as='p' fontWeight='semibold'>{t("Total Amount")}</Text>
                                        </div>
                                        <Text as='p'>{modalData?.['marketplace_currency']} {modalData?.['total']?.['marketplace_price']}</Text>
                                    </InlineStack>
                                }
                            />
                        </Card>
                        <BlockStack gap='200'>
                            <InlineStack gap='200'>
                                <Text as='p' fontWeight='semibold'>{t("Canceled Status")} : </Text>
                                <Badge tone="critical">{modalData?.cancellation_status ?? "---"}</Badge>
                            </InlineStack>
                            <InlineStack gap='200'>
                                <Text as='p' fontWeight='semibold'>{t("Canceled Failed Reason")} : </Text>
                                {Array.isArray(modalData?.cancel_failed_reason) ? <Text as='p'>{modalData?.cancel_failed_reason?.[0] ?? "---"}</Text> : <Text as='p'>{modalData?.cancel_failed_reason ?? "---"}</Text>}
                            </InlineStack>
                            <InlineStack gap='200' blockAlign='center'>
                                <InlineStack gap='100'><Text as='p' tone='critical'>*</Text><Text as='p' fontWeight='semibold'>{t("Shopify Canceled Reason")} :  </Text></InlineStack>
                                <Select
                                    value={shopifyReason}
                                    onChange={(e) => { setShopifyReason(e); setShopifyError(e == "") }}
                                    label=''
                                    options={shopifyReasonOpt}
                                    error={shopifyError}
                                />
                            </InlineStack>
                        </BlockStack>
                    </BlockStack>,
                    true,
                )
            }

            {
                customModal(
                    activateConfirmationModal,
                    () => setactivateConfirmationModal(false),
                    `${t("Failed Canceled Order")}`,
                    {
                        content: t('Confirm'),
                        onAction: handleConfirmationModal,
                        loading: cancelLoader
                    },
                    <Text as='p'>{t("Are you sure you want to cancel this order?")}</Text>,
                    false,
                    [
                        {
                            content: t('No'),
                            onAction: () => setactivateConfirmationModal(false),
                            disabled: cancelLoader
                        }
                    ]
                )
            }

            {/* Refund Modal */}
            {/* {
                customModal(
                    failedRefundOrderModal,
                    () => {
                        setRefundModalGridRows([]);
                        setFailedRefundOrderModal(false);
                    },
                    `Refund Order (${row?.marketplace_reference_id})`,
                    { content: 'Confirm', onAction: handleRefundOrderConfirmation },
                    <Card padding='0'>
                        <Table
                            columns={refundModalGridCols}
                            dataSource={[...refundModalGridRows]}
                            scroll={{ x: 900 }}
                            pagination={false}
                            loading={refloader}
                            rowSelection={{ type: 'checkbox', ...rowSelection }}
                            footer={() => <>
                                <InlineStack gap="400">
                                    <div className='Custom-Stack-Item--fill'>
                                        <Text as='p' fontWeight='semibold'>{t("Total Refund Amount")}</Text>
                                    </div>
                                    <Text as='p'>{refundmodalData?.['marketplace_currency']} {selectedRowIndexes.length > 0 ? (getTotalRefundAmount() ?? 0.0) : 0.0}</Text>
                                </InlineStack>
                            </>}
                        />
                    </Card>,
                    true,
                    [
                        {
                            content: 'Cancel',
                            onAction: () => {
                                setRefundModalData({});
                                setRefundModalGridRows([]);
                                setFailedRefundOrderModal(false);
                            },
                        }
                    ]
                )
            } */}

            {failedRefundOrderModal && <RefundModal modalDataForFutureUse={modalDataForFutureUse} setselectedRowIndexes={setselectedRowIndexes} selectedRowIndexes={selectedRowIndexes} handleRefundOrderConfirmation={handleRefundOrderConfirmation} rowSelection={rowSelection} refundmodalData={refundmodalData} setErrors={setErrors} errors={errors} setRefundModalData={setRefundModalData} handleRefundModalClose={handleRefundModalClose} row={row} open={failedRefundOrderModal}></RefundModal>}

            {
                customModal(
                    activateConfirmationRefundModal,
                    () => handleConfirmationModalClose(),
                    `${t("Failed Refund Order")}`,
                    {
                        content: t('Yes'),
                        onAction: handleRefundConfirmationModal,
                        loading: refundLoader
                    },
                    <Text as='p'>{t("Are you sure you want to refund this order?")}</Text>,
                    false,
                    [
                        {
                            content: t('No'),
                            onAction: handleConfirmationModalClose,
                            disabled: refundLoader
                        }
                    ]
                )
            }

        </React.Fragment>
    );
}

export default DI(RenderSyncStatus)